module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo04_thumb-ff2970d568810eff1a3d9e06d538ea96.jpg";